import { Component } from '@angular/core';

@Component({
  selector: 'fgb-membership-page',
  templateUrl: './membership-page.component.html',
  styleUrls: ['./membership-page.component.scss'],
})
export class MembershipPageComponent {}
